import * as React from 'react'
import classNames from 'classnames'
import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'

interface Props {
    deps: CommonDeps
    header: string | React.ReactNode
    leftAligned?: boolean
    subheader?: React.ReactNode
    time?: string
    dark?: boolean
}

export class TopBarTitle extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    public static defaultProps: Partial<Props> = {
        leftAligned: false,
    }

    public tryRender = () => {
        const { leftAligned, time, dark } = this.props
        return (
            <div className={classNames('AppCore__page__TopBarTitle', { dark })}>
                <div
                    className={classNames('AppCore__page__TopBarTitle__topRow', {
                        centered: !leftAligned,
                    })}
                >
                    {this.renderHeader()}
                    {time && <div className="AppCore__page__TopBarTitle__time">{time}</div>}
                </div>
                {this.renderSubheader()}
            </div>
        )
    }

    private renderHeader() {
        const { header, subheader } = this.props

        return (
            header && (
                <zaptic-ellipsis
                    class={
                        subheader ? 'AppCore__page__TopBarTitle__header' : 'AppCore__page__TopBarTitle__header-alone'
                    }
                    data-testid="top-bar-title"
                >
                    {header}
                </zaptic-ellipsis>
            )
        )
    }

    private renderSubheader() {
        const { leftAligned, subheader } = this.props
        return (
            subheader && (
                <zaptic-ellipsis
                    class={classNames('AppCore__page__TopBarTitle__subheader', {
                        centered: !leftAligned,
                    })}
                >
                    {subheader}
                </zaptic-ellipsis>
            )
        )
    }
}
